class MFRBuildAKit {
  constructor(index, element) {
    this.$index = index;
    this.$element = $(element);

    this.selectors = {
      autoplayOnHoverState: ".autoplay-hover--enabled"
    }

    this.init();
  }

  init() {
    this.initializedPosters();
  }

  initializedPosters() {
    $(document).ready(() => {
      // need to re-assign poster to make poster appear
      const videos = this.$element.find("video");

      videos.each((index, e) => {
        const poster = $(e).attr("poster");
        if (poster) {
          $(e).attr("poster", `${poster}`);
        }
      });
    })
  }
}